import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 1,
  style: {"height":"90vh"},
  class: "ofs"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "w100 title mc mt40" }, [
  /*#__PURE__*/_createElementVNode("p", {
    class: "header_title fs24 centered",
    style: {"color":"#696969","float":"none"}
  }, /*#__PURE__*/_toDisplayString(`一斉に確定`))
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_4 = {
  class: "w100",
  style: {"padding":"0 40px 0 40px","height":"100vh"}
}
const _hoisted_5 = {
  class: "",
  style: {}
}
const _hoisted_6 = { class: "fl" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "fl mt3" }, "カスタム確定に変更", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_9 = {
  key: 1,
  class: "ml15"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_11 = { class: "mt10 mb10 ml10" }
const _hoisted_12 = { class: "fl mr20" }
const _hoisted_13 = { class: "fl" }
const _hoisted_14 = {
  key: 0,
  class: "fs14 fw600"
}
const _hoisted_15 = { class: "fs24 fw600 arial" }
const _hoisted_16 = {
  key: 1,
  class: "fs14 fw600"
}
const _hoisted_17 = { class: "fl" }
const _hoisted_18 = { class: "fs24 fw600 arial" }
const _hoisted_19 = ["src"]
const _hoisted_20 = /*#__PURE__*/_createElementVNode("p", { class: "fl mt6 fs14 mr4" }, "出席者を変更", -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_23 = { key: 0 }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_27 = { class: "w100 mt20" }
const _hoisted_28 = ["src"]
const _hoisted_29 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_30 = {
  key: 0,
  class: "fw600 fs12 alertRed ml20 fl"
}
const _hoisted_31 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_32 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_33 = {
  key: 0,
  class: "w100 mt20"
}
const _hoisted_34 = ["src"]
const _hoisted_35 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_36 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_37 = {
  key: 1,
  class: "w100 pad10"
}
const _hoisted_38 = ["src"]
const _hoisted_39 = { class: "fs12" }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("span", null, "担当", -1)
const _hoisted_41 = {
  key: 1,
  class: "fw600"
}
const _hoisted_42 = /*#__PURE__*/_createElementVNode("p", { class: "fw600 fs11" }, "※ 担当を指定した場合、その担当で強制確定します", -1)
const _hoisted_43 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_44 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_45 = {
  key: 2,
  class: "w100 pad10"
}
const _hoisted_46 = ["src"]
const _hoisted_47 = {
  key: 0,
  class: "fs12"
}
const _hoisted_48 = { class: "fw600" }
const _hoisted_49 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_50 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_51 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_52 = {
  class: "w100 posAb",
  style: {"bottom":"0"}
}
const _hoisted_53 = {
  class: "posAb w50 centered",
  style: {"left":"0","bottom":"0"}
}
const _hoisted_54 = /*#__PURE__*/_createElementVNode("span", { class: "fs14 fw400" }, "キャンセル", -1)
const _hoisted_55 = [
  _hoisted_54
]
const _hoisted_56 = {
  class: "posAb w50 centered",
  style: {"right":"0","bottom":"0"}
}
const _hoisted_57 = /*#__PURE__*/_createElementVNode("div", {
  class: "fs14 whiteColor fw600",
  style: {"padding-top":"15px"}
}, "確定", -1)
const _hoisted_58 = [
  _hoisted_57
]
const _hoisted_59 = {
  key: 2,
  style: {"height":"90vh"},
  class: ""
}
const _hoisted_60 = { class: "w100 mb10" }
const _hoisted_61 = { class: "fl ml40 mt20" }
const _hoisted_62 = ["src"]
const _hoisted_63 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_64 = {
  class: "fl ofs w100",
  style: {"padding":"0 0 0 40px","height":"calc(90vh - 66px)"}
}
const _hoisted_65 = {
  key: 3,
  style: {"height":"90vh"},
  class: "ofs"
}
const _hoisted_66 = { class: "w100 mb10" }
const _hoisted_67 = { class: "fl ml40 mt20" }
const _hoisted_68 = ["src"]
const _hoisted_69 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_70 = {
  key: 4,
  style: {"height":"90vh"},
  class: "ofs"
}
const _hoisted_71 = { class: "w100 mb10" }
const _hoisted_72 = { class: "fl ml40 mt20" }
const _hoisted_73 = ["src"]
const _hoisted_74 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_md_progress_bar = _resolveComponent("md-progress-bar")!
  const _component_Switcher = _resolveComponent("Switcher")!
  const _component_PossibleDateControl = _resolveComponent("PossibleDateControl")!
  const _component_ChangeableDateTimeContent = _resolveComponent("ChangeableDateTimeContent")!
  const _component_SelectTag = _resolveComponent("SelectTag")!
  const _component_UserIcon = _resolveComponent("UserIcon")!
  const _component_LocationSelectContent = _resolveComponent("LocationSelectContent")!
  const _component_FixVotedRoomsMailContent = _resolveComponent("FixVotedRoomsMailContent")!
  const _component_SelectAttendeesWithAddressbook = _resolveComponent("SelectAttendeesWithAddressbook")!
  const _component_MeetingAttendeesGroupAssignContent = _resolveComponent("MeetingAttendeesGroupAssignContent")!
  const _component_FixAppoInfoContent = _resolveComponent("FixAppoInfoContent")!
  const _component_VueFinalModal = _resolveComponent("VueFinalModal")!

  return (_openBlock(), _createBlock(_component_VueFinalModal, {
    "modal-id": "FixVotedRoomsModal",
    "content-class": "modalContent shadowContent rad10 modalWide posFi",
    onBeforeOpen: _ctx.openModal
  }, {
    default: _withCtx(() => [
      (_ctx.vrm.loading)
        ? (_openBlock(), _createBlock(_component_md_progress_bar, { key: 0 }))
        : _createCommentVNode("", true),
      (_ctx.viewType == `appo`)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _hoisted_2,
            _hoisted_3,
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_component_Switcher, {
                    value: "type[is_force]",
                    name: "設定の有効",
                    checked: _ctx.isForce,
                    display: "true",
                    class: "checkUsingCal fl",
                    style: {"transform":"scale(0.5)"},
                    onSelect: _ctx.changeForce
                  }, null, 8, ["checked", "onSelect"]),
                  _hoisted_7
                ]),
                _hoisted_8,
                (!_ctx.isForce)
                  ? (_openBlock(), _createBlock(_component_PossibleDateControl, {
                      key: 0,
                      controlPressKey: false
                    }))
                  : (_openBlock(), _createElementBlock("div", _hoisted_9, [
                      _createVNode(_component_ChangeableDateTimeContent, {
                        changeableEv: _ctx.changeableEv,
                        onUpdateAppoTime: _ctx.updateAppoTime
                      }, null, 8, ["changeableEv", "onUpdateAppoTime"])
                    ]))
              ]),
              _hoisted_10,
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _createVNode(_component_SelectTag, {
                    name: "fix_vote_type",
                    id: "fix_vote_type",
                    class: "fs14 roundForm",
                    style: {"min-width":"360px","height":"50px"},
                    options: _ctx.SelectUtil.votedRoomFixTypes.map(e => e.name),
                    defaultOption: _ctx.defaultVotedOption(),
                    onSelectValue: _ctx.selectVoteFixType,
                    isDisabled: false
                  }, null, 8, ["options", "defaultOption", "onSelectValue"])
                ]),
                _createElementVNode("div", _hoisted_13, [
                  (_ctx.vrm.fixVoteType == `all`)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                        _createElementVNode("span", _hoisted_15, _toDisplayString((_ctx.vrm.rooms || []).length), 1),
                        _createTextVNode("人全員に確定通知を送信します。 ")
                      ]))
                    : (_ctx.vrm.fixVoteType == `attendees_only`)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                          _createElementVNode("p", _hoisted_17, [
                            _createElementVNode("span", _hoisted_18, _toDisplayString((_ctx.attendees || []).length), 1),
                            _createTextVNode("人に確定通知を送信します。 ")
                          ]),
                          _createElementVNode("div", {
                            class: "fl ml10 fs12 fw600 circle_button blueAround rad8 padw4",
                            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.addAttendeeFromAddressBook && _ctx.addAttendeeFromAddressBook(...args))),
                            style: {"margin-top":"-6px"}
                          }, [
                            _createElementVNode("img", {
                              src: _ctx.$getAssetImageUrl(`/assets/icons/user_plus.png`),
                              width: "22",
                              height: "22",
                              class: "fl mt4 mr3"
                            }, null, 8, _hoisted_19),
                            _hoisted_20,
                            _hoisted_21
                          ]),
                          _hoisted_22
                        ]))
                      : _createCommentVNode("", true),
                  _createElementVNode("div", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.attendees, (mem, memindex) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "fl",
                        key: memindex
                      }, [
                        _createVNode(_component_UserIcon, {
                          member: mem,
                          width: 18,
                          canEdit: false,
                          updateSelf: false,
                          showTooltip: true,
                          class: "pointer mb3 mr3"
                        }, null, 8, ["member"])
                      ]))
                    }), 128)),
                    (_ctx.vrm.fixVoteType == `all`)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.vrm.notAttendees, (mem, memindex) => {
                            return (_openBlock(), _createElementBlock("div", {
                              class: "fl",
                              key: memindex
                            }, [
                              _createVNode(_component_UserIcon, {
                                member: mem,
                                width: 18,
                                canEdit: false,
                                updateSelf: false,
                                showTooltip: true,
                                class: "pointer mt3 mr3"
                              }, null, 8, ["member"])
                            ]))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _hoisted_24
                ]),
                _hoisted_25
              ]),
              _hoisted_26,
              _createElementVNode("div", _hoisted_27, [
                _createElementVNode("img", {
                  src: _ctx.$getAssetImageUrl(`/assets/icons/mappin.png`),
                  width: "22",
                  height: "22",
                  class: "fl mr5 mt12 ml10"
                }, null, 8, _hoisted_28),
                _createVNode(_component_LocationSelectContent, {
                  class: "fl",
                  locationName: _ctx.getLocationName,
                  astag: _ctx.astag,
                  maxLength: 1,
                  onUpdate: _ctx.updateLocation
                }, null, 8, ["locationName", "astag", "onUpdate"]),
                _hoisted_29,
                ((_ctx.currentOnlines || []).length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_30, " ※ アカウントを選択した場合、強制確定となります "))
                  : _createCommentVNode("", true),
                _hoisted_31
              ]),
              _hoisted_32,
              false
                ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                    _createElementVNode("img", {
                      src: _ctx.$getAssetImageUrl(`/assets/icons/user_plus.png`),
                      width: "22",
                      height: "22",
                      class: "fl mr5 mt12 ml10"
                    }, null, 8, _hoisted_34)
                  ]))
                : _createCommentVNode("", true),
              _hoisted_35,
              _createVNode(_component_FixVotedRoomsMailContent, { onInputMessage: _ctx.inputMessage }, null, 8, ["onInputMessage"]),
              _hoisted_36,
              (_ctx.room && (_ctx.room.is_owner || _ctx.room.is_shared))
                ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                    _createElementVNode("div", {
                      class: _normalizeClass(`w100 mt10 text-left pointer rad8`),
                      style: {"border":"1px solid #dfdfdf","padding":"12px 0"},
                      onClick: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.clickShowMeetingAttendeesGroupAssignContent && _ctx.clickShowMeetingAttendeesGroupAssignContent(...args)), ["self"]))
                    }, [
                      _createElementVNode("img", {
                        src: _ctx.$getAssetImageUrl(`/assets/icons/waaq_members.png`),
                        width: "26",
                        height: "20",
                        style: {"margin-top":"1px"},
                        class: "fl mr2 ml10",
                        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.clickShowMeetingAttendeesGroupAssignContent && _ctx.clickShowMeetingAttendeesGroupAssignContent(...args)))
                      }, null, 8, _hoisted_38),
                      _createElementVNode("label", {
                        class: "fl fs18 fw600 ddgrey text-left ml15 mt1 mr5",
                        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.clickShowMeetingAttendeesGroupAssignContent && _ctx.clickShowMeetingAttendeesGroupAssignContent(...args)))
                      }, "担当者を設定 "),
                      (_ctx.fixMag)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: "fl",
                            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.clickShowMeetingAttendeesGroupAssignContent && _ctx.clickShowMeetingAttendeesGroupAssignContent(...args)))
                          }, [
                            _createElementVNode("div", _hoisted_39, [
                              (_ctx.fixMag.profile_image_urls && _ctx.fixMag.profile_image_urls[0])
                                ? (_openBlock(), _createBlock(_component_UserIcon, {
                                    key: 0,
                                    imageUrl: (_ctx.fixMag.profile_image_urls || [])[0],
                                    canEdit: false,
                                    updateSelf: false,
                                    width: 30,
                                    class: "fl mr10",
                                    style: {"margin-left":"-1px"}
                                  }, null, 8, ["imageUrl"]))
                                : _createCommentVNode("", true),
                              _hoisted_40,
                              (_ctx.fixMag.team_name)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_41, [
                                    _createTextVNode("「"),
                                    _createElementVNode("span", null, _toDisplayString(_ctx.fixMag.team_name), 1),
                                    _createTextVNode("」")
                                  ]))
                                : _createCommentVNode("", true),
                              _createTextVNode("が選択されています ")
                            ]),
                            _hoisted_42
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.fixMag)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 1,
                            class: "pointer underline skyblue fw600 fr fs12 mr20 mt3",
                            onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.resetMeetingAttendeesGroup && _ctx.resetMeetingAttendeesGroup(...args)))
                          }, " 担当者をリセット "))
                        : _createCommentVNode("", true),
                      _hoisted_43
                    ])
                  ]))
                : _createCommentVNode("", true),
              _hoisted_44,
              (_ctx.showFixAppoMenu())
                ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                    _createElementVNode("div", {
                      class: _normalizeClass(`w100 mt10 text-left pointer rad8`),
                      style: {"border":"1px solid #dfdfdf","padding":"12px 0"},
                      onClick: _cache[10] || (_cache[10] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.clickEditFixInfo && _ctx.clickEditFixInfo(...args)), ["self"]))
                    }, [
                      _createElementVNode("img", {
                        src: _ctx.$getAssetImageUrl(`/assets/icons/waaq_members.png`),
                        width: "26",
                        height: "20",
                        style: {"margin-top":"1px"},
                        class: "fl mr2 ml10",
                        onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.clickEditFixInfo && _ctx.clickEditFixInfo(...args)))
                      }, null, 8, _hoisted_46),
                      _createElementVNode("label", {
                        class: "fl fs18 fw600 ddgrey text-left ml15 mt1 mr5",
                        onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.clickEditFixInfo && _ctx.clickEditFixInfo(...args)))
                      }, "確定情報を設定 "),
                      (_ctx.fixedAppoDic?.f_appo)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: "fl",
                            onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.clickEditFixInfo && _ctx.clickEditFixInfo(...args)))
                          }, [
                            (_ctx.fixedAppoDic?.f_appo?.name)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                                  _createElementVNode("span", _hoisted_48, [
                                    _createTextVNode("「"),
                                    _createElementVNode("span", null, _toDisplayString(_ctx.fixedAppoDic.f_appo.name), 1),
                                    _createTextVNode("」")
                                  ]),
                                  _createTextVNode("の確定 ")
                                ]))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.fixedAppoDic?.f_appo?.name)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 1,
                            class: "pointer underline skyblue fw600 fr fs12 mr20 mt3",
                            onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.resetFixedAppoDic && _ctx.resetFixedAppoDic(...args)))
                          }, " 調整名をリセット "))
                        : _createCommentVNode("", true),
                      _hoisted_49
                    ])
                  ]))
                : _createCommentVNode("", true),
              _hoisted_50
            ]),
            _hoisted_51,
            _createElementVNode("div", _hoisted_52, [
              _createElementVNode("div", _hoisted_53, [
                _createElementVNode("section", {
                  class: "llgreyBg dgrey fs16 pointer centered",
                  style: {"line-height":"50px","height":"50px"},
                  onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.clickCancel && _ctx.clickCancel(...args)))
                }, _hoisted_55)
              ]),
              _createElementVNode("div", _hoisted_56, [
                _createElementVNode("section", {
                  class: "w100 skyblueBg fs16 pointer centered",
                  style: {"line-height":"50px","height":"50px"},
                  onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.clickOK && _ctx.clickOK(...args)))
                }, _hoisted_58)
              ])
            ])
          ]))
        : (_ctx.viewType == `attendees`)
          ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
              _createElementVNode("div", _hoisted_60, [
                _createElementVNode("div", _hoisted_61, [
                  _createElementVNode("img", {
                    src: _ctx.$getAssetImageUrl(`/assets/icons/arrow_left.png`),
                    width: "36",
                    height: "36",
                    class: "pointer",
                    onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.clickPreStep && _ctx.clickPreStep(...args)))
                  }, null, 8, _hoisted_62)
                ]),
                _hoisted_63
              ]),
              _createElementVNode("div", _hoisted_64, [
                _createVNode(_component_SelectAttendeesWithAddressbook, {
                  height: `calc(90vh - 66px)`,
                  viewType: _ctx.viewType
                }, null, 8, ["height", "viewType"])
              ])
            ]))
          : (_ctx.viewType == `mags`)
            ? (_openBlock(), _createElementBlock("div", _hoisted_65, [
                _createElementVNode("div", _hoisted_66, [
                  _createElementVNode("div", _hoisted_67, [
                    _createElementVNode("img", {
                      src: _ctx.$getAssetImageUrl(`/assets/icons/arrow_left.png`),
                      width: "36",
                      height: "36",
                      class: "pointer",
                      onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.clickPreStepFromMags && _ctx.clickPreStepFromMags(...args)))
                    }, null, 8, _hoisted_68)
                  ]),
                  _hoisted_69
                ]),
                _createVNode(_component_MeetingAttendeesGroupAssignContent, {
                  onSelectMag: _ctx.selectMag,
                  onSelectCategoryTab: _ctx.selectCategoryTab,
                  onUpdateTmpMag: _ctx.updateTmpMag
                }, null, 8, ["onSelectMag", "onSelectCategoryTab", "onUpdateTmpMag"])
              ]))
            : (_ctx.viewType == `fix_appo_info`)
              ? (_openBlock(), _createElementBlock("div", _hoisted_70, [
                  _createElementVNode("div", _hoisted_71, [
                    _createElementVNode("div", _hoisted_72, [
                      _createElementVNode("img", {
                        src: _ctx.$getAssetImageUrl(`/assets/icons/arrow_left.png`),
                        width: "36",
                        height: "36",
                        class: "pointer",
                        onClick: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.clickPreStepFromFixAppoInfo && _ctx.clickPreStepFromFixAppoInfo(...args)))
                      }, null, 8, _hoisted_73)
                    ]),
                    _hoisted_74
                  ]),
                  _createVNode(_component_FixAppoInfoContent, {
                    attendees: _ctx.attendees,
                    fAppoDic: _ctx.fixedAppoDic,
                    onUpdateFixedAppo: _ctx.updateFixedAppo
                  }, null, 8, ["attendees", "fAppoDic", "onUpdateFixedAppo"])
                ]))
              : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["onBeforeOpen"]))
}